import Vue from 'vue';
import '@/assets/stylesheets/v2/_overlay-loader.scss';
export default Vue.extend({
    props: {
        toggle: {
            type: Boolean,
            default: true,
        },
        loadingTitle: {
            type: String,
            required: false,
            default: '',
        },
    },
    render(createElement) {
        return createElement('v-dialog', {
            props: {
                value: this.toggle,
                persistent: true,
                contentClass: 'overlay-loader',
            },
        }, [
            createElement('div', { class: 'card' }, [
                createElement('v-progress-circular', {
                    props: {
                        indeterminate: true,
                        size: 64,
                    },
                }),
                createElement('div', {
                    class: 'subheading text-xs-center mt-3 font-weight-bold white--text',
                    style: { 'display: none': !this.loadingTitle },
                }, [`${this.loadingTitle}`]),
            ]),
        ]);
    },
});
